var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g2, _path18, _path19, _g3, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g4, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g5, _path44, _path45, _g6, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMissingProfileImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 419 627"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "missing-profile-image_svg__a",
  width: 420,
  height: 627,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.002.25h419v626.131h-419z"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#missing-profile-image_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "missing-profile-image_svg__b",
  width: 420,
  height: 420,
  x: -1,
  y: 16,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M209.458 435.43c115.704 0 209.5-93.797 209.5-209.5s-93.796-209.5-209.5-209.5-209.5 93.796-209.5 209.5 93.796 209.5 209.5 209.5"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#missing-profile-image_svg__b)"
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M412.775 98.679a10.1 10.1 0 0 0-10.102-10.103H16.153a10.1 10.1 0 0 0-10.1 10.103v304.162c0 5.578 4.522 10.103 10.1 10.103h386.52c5.58 0 10.102-4.525 10.102-10.103z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "missing-profile-image_svg__c",
  width: 407,
  height: 325,
  x: 6,
  y: 88,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M412.775 98.679a10.1 10.1 0 0 0-10.102-10.103H16.153a10.1 10.1 0 0 0-10.1 10.103v304.162c0 5.578 4.522 10.103 10.1 10.103h386.52c5.58 0 10.102-4.525 10.102-10.103z"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#missing-profile-image_svg__c)"
}, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#336468",
  fillRule: "evenodd",
  d: "M368.318 145.011c0-1.98-1.614-3.6-3.602-3.6H54.118a3.607 3.607 0 0 0-3.602 3.6v64.84c0 1.98 1.614 3.6 3.602 3.6h310.598a3.607 3.607 0 0 0 3.602-3.6z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "missing-profile-image_svg__d",
  width: 319,
  height: 73,
  x: 50,
  y: 141,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M368.318 145.011c0-1.98-1.614-3.6-3.602-3.6H54.118a3.607 3.607 0 0 0-3.602 3.6v64.84c0 1.98 1.614 3.6 3.602 3.6h310.598a3.607 3.607 0 0 0 3.602-3.6z"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#missing-profile-image_svg__d)"
}, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  d: "M88.985 203.818c14.574 0 26.389-11.814 26.389-26.388s-11.815-26.389-26.389-26.389-26.388 11.815-26.388 26.389 11.814 26.388 26.388 26.388"
})), /*#__PURE__*/React.createElement("mask", {
  id: "missing-profile-image_svg__e",
  width: 54,
  height: 53,
  x: 62,
  y: 151,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M88.985 203.818c14.574 0 26.389-11.814 26.389-26.388s-11.815-26.389-26.389-26.389-26.388 11.815-26.388 26.389 11.814 26.388 26.388 26.388"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#75959A",
  mask: "url(#missing-profile-image_svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M88.985 213.891c9.954 0 18.023-5.791 18.023-12.934 0-7.144-8.07-12.935-18.023-12.935-9.954 0-18.023 5.791-18.023 12.935 0 7.143 8.07 12.934 18.023 12.934"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M88.965 185.495s8.234-.487 8.234-14.443a8.24 8.24 0 0 0-8.234-8.234 8.24 8.24 0 0 0-8.234 8.234c0 13.956 8.234 14.443 8.234 14.443",
  clipRule: "evenodd"
}))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M88.985 151.041c14.565 0 26.389 11.824 26.389 26.389s-11.824 26.388-26.389 26.388-26.388-11.824-26.388-26.388 11.824-26.389 26.388-26.389m0 2c-13.46 0-24.388 10.928-24.388 24.389s10.928 24.388 24.388 24.388 24.389-10.928 24.389-24.388-10.928-24.389-24.389-24.389",
  clipRule: "evenodd"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M242.737 152.664c0-.892-.726-1.622-1.621-1.622H126.084c-.893 0-1.619.73-1.619 1.622v12.956c0 .892.726 1.622 1.619 1.622h115.032c.895 0 1.621-.73 1.621-1.622z",
  clipRule: "evenodd"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M242.737 152.664v12.956c0 .892-.726 1.622-1.621 1.622H126.084c-.893 0-1.619-.73-1.619-1.622v-12.956c0-.892.726-1.622 1.619-1.622h115.032c.895 0 1.621.73 1.621 1.622",
  clipRule: "evenodd"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M221.357 178.786a.85.85 0 0 0-.849-.849h-95.199a.85.85 0 0 0-.848.849v6.786c0 .467.38.849.848.849h95.199a.85.85 0 0 0 .849-.849z",
  clipRule: "evenodd"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M221.357 178.786v6.786a.85.85 0 0 1-.849.849h-95.199a.85.85 0 0 1-.848-.849v-6.786a.85.85 0 0 1 .848-.849h95.199a.85.85 0 0 1 .849.849",
  clipRule: "evenodd"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M256.292 196.185a.85.85 0 0 0-.849-.849H125.309a.85.85 0 0 0-.848.849v6.786c0 .467.38.85.848.85h130.134a.85.85 0 0 0 .849-.85z",
  clipRule: "evenodd"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M256.292 196.185v6.786c0 .467-.38.85-.849.85H125.309a.85.85 0 0 1-.848-.85v-6.786a.85.85 0 0 1 .848-.849h130.134a.85.85 0 0 1 .849.849",
  clipRule: "evenodd"
}))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#336468",
  fillRule: "evenodd",
  d: "M368.314 292.261a4.01 4.01 0 0 0-4.004-4.002H217.158a4.01 4.01 0 0 0-4.005 4.002v72.086a4.01 4.01 0 0 0 4.005 4.002H364.31a4.01 4.01 0 0 0 4.004-4.002z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "missing-profile-image_svg__f",
  width: 156,
  height: 81,
  x: 213,
  y: 288,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M368.314 292.261a4.01 4.01 0 0 0-4.004-4.002H217.158a4.01 4.01 0 0 0-4.005 4.002v72.086a4.01 4.01 0 0 0 4.005 4.002H364.31a4.01 4.01 0 0 0 4.004-4.002z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#missing-profile-image_svg__f)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M254.157 308.305a.6.6 0 0 0-.601-.601h-35.583c-.331 0-.6.27-.6.601v4.799c0 .331.269.601.6.601h35.583c.332 0 .601-.27.601-.601z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M254.157 308.305v4.799a.6.6 0 0 1-.601.601h-35.583c-.331 0-.6-.27-.6-.601v-4.799c0-.331.269-.601.6-.601h35.583c.332 0 .601.27.601.601",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M364.095 324.885a.09.09 0 0 0-.089-.088H217.459a.09.09 0 0 0-.087.088v.704c0 .048.039.088.087.088h146.547a.09.09 0 0 0 .089-.088z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M364.095 324.885v.704a.09.09 0 0 1-.089.088H217.459a.09.09 0 0 1-.087-.088v-.704c0-.048.039-.088.087-.088h146.547a.09.09 0 0 1 .089.088",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M235.764 332.511a.6.6 0 0 0-.6-.601h-17.192c-.331 0-.6.271-.6.601v4.799c0 .331.269.601.6.601h17.192c.331 0 .6-.27.6-.601z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M235.764 332.511v4.799a.6.6 0 0 1-.6.601h-17.192c-.331 0-.6-.27-.6-.601v-4.799c0-.33.269-.601.6-.601h17.192c.331 0 .6.271.6.601",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M364.095 349.092a.09.09 0 0 0-.089-.088H217.459a.09.09 0 0 0-.087.088v.704c0 .048.039.088.087.088h146.547a.09.09 0 0 0 .089-.088z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M364.095 349.092v.704a.09.09 0 0 1-.089.088H217.459a.09.09 0 0 1-.087-.088v-.704c0-.048.039-.088.087-.088h146.547a.09.09 0 0 1 .089.088",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  d: "M368.314 288.265H213.153v13.21h155.161z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4C767C",
  d: "M368.314 288.265H213.153v13.21h155.161z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M268.248 291.672a.803.803 0 0 0-.8-.801h-49.276c-.441 0-.8.361-.8.801v6.399c0 .441.359.801.8.801h49.276c.441 0 .8-.36.8-.801z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M268.248 291.672v6.399a.8.8 0 0 1-.8.801h-49.276c-.441 0-.8-.36-.8-.801v-6.399c0-.44.359-.801.8-.801h49.276c.441 0 .8.361.8.801",
  clipRule: "evenodd"
}))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#336468",
  fillRule: "evenodd",
  d: "M205.674 292.261a4.01 4.01 0 0 0-4.005-4.002H54.517a4.01 4.01 0 0 0-4.004 4.002v72.086a4.01 4.01 0 0 0 4.004 4.002H201.67a4.01 4.01 0 0 0 4.005-4.002z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "missing-profile-image_svg__g",
  width: 156,
  height: 81,
  x: 50,
  y: 288,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M205.674 292.261a4.01 4.01 0 0 0-4.005-4.002H54.517a4.01 4.01 0 0 0-4.004 4.002v72.086a4.01 4.01 0 0 0 4.004 4.002H201.67a4.01 4.01 0 0 0 4.005-4.002z"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#missing-profile-image_svg__g)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  d: "M205.673 288.265H50.513v13.21h155.16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4C767C",
  d: "M205.673 288.265H50.513v13.21h155.16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M105.607 291.672a.8.8 0 0 0-.8-.801H55.532c-.442 0-.8.361-.8.801v6.399c0 .441.358.801.8.801h49.275c.442 0 .8-.36.8-.801z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M105.607 291.672v6.399a.8.8 0 0 1-.8.801H55.532c-.442 0-.8-.36-.8-.801v-6.399c0-.44.358-.801.8-.801h49.275c.442 0 .8.361.8.801",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M82.64 308.308a.6.6 0 0 0-.6-.601H55.332c-.33 0-.6.27-.6.601v4.799c0 .331.27.601.6.601H82.04c.33 0 .6-.27.6-.601z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M82.64 308.308v4.799a.6.6 0 0 1-.6.601H55.332c-.33 0-.6-.27-.6-.601v-4.799c0-.331.27-.601.6-.601H82.04c.33 0 .6.27.6.601",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4C767C",
  fillRule: "evenodd",
  d: "M201.454 317.372a1.21 1.21 0 0 0-1.206-1.208H55.936c-.665 0-1.205.544-1.205 1.208v9.647c0 .664.54 1.208 1.205 1.208h144.312a1.21 1.21 0 0 0 1.206-1.208z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M201.454 317.372v9.647a1.21 1.21 0 0 1-1.206 1.208H55.936a1.21 1.21 0 0 1-1.205-1.208v-9.647c0-.664.54-1.208 1.205-1.208h144.312a1.21 1.21 0 0 1 1.206 1.208m-.9 0a.305.305 0 0 0-.306-.309H55.936a.304.304 0 0 0-.304.309v9.647c0 .168.137.302.304.302h144.312a.303.303 0 0 0 .306-.302z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M114.567 320.182a.505.505 0 0 0-.503-.504H58.58a.505.505 0 0 0-.504.504v4.026c0 .278.226.504.504.504h55.484a.504.504 0 0 0 .503-.504z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M114.567 320.182v4.026a.504.504 0 0 1-.503.504H58.58a.504.504 0 0 1-.504-.504v-4.026c0-.277.226-.504.504-.504h55.484c.277 0 .503.227.503.504",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4C767C",
  fillRule: "evenodd",
  d: "M201.454 334.315a1.21 1.21 0 0 0-1.206-1.208H55.936c-.665 0-1.205.544-1.205 1.208v9.648c0 .664.54 1.207 1.205 1.207h144.312c.665 0 1.206-.543 1.206-1.207z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M201.454 334.315v9.648c0 .664-.541 1.207-1.206 1.207H55.936a1.21 1.21 0 0 1-1.205-1.207v-9.648c0-.664.54-1.208 1.205-1.208h144.312a1.21 1.21 0 0 1 1.206 1.208m-.9 0a.305.305 0 0 0-.306-.309H55.936a.305.305 0 0 0-.304.309v9.648c0 .167.137.301.304.301h144.312a.303.303 0 0 0 .306-.301z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M114.567 337.125a.505.505 0 0 0-.503-.504H58.58a.505.505 0 0 0-.504.504v4.027c0 .277.226.504.504.504h55.484a.505.505 0 0 0 .503-.504z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M114.567 337.125v4.027a.505.505 0 0 1-.503.504H58.58a.505.505 0 0 1-.504-.504v-4.027c0-.277.226-.504.504-.504h55.484c.277 0 .503.227.503.504",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4C767C",
  fillRule: "evenodd",
  d: "M201.454 351.258c0-.664-.541-1.207-1.206-1.207H55.936c-.665 0-1.205.543-1.205 1.207v9.648c0 .664.54 1.208 1.205 1.208h144.312a1.21 1.21 0 0 0 1.206-1.208z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M201.454 351.258v9.648a1.21 1.21 0 0 1-1.206 1.208H55.936a1.21 1.21 0 0 1-1.205-1.208v-9.648c0-.664.54-1.207 1.205-1.207h144.312c.665 0 1.206.543 1.206 1.207m-.9 0a.305.305 0 0 0-.306-.308H55.936a.304.304 0 0 0-.304.308v9.648c0 .168.137.302.304.302h144.312a.303.303 0 0 0 .306-.302z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M102.984 337.125a.505.505 0 0 0-.504-.504h-43.9a.505.505 0 0 0-.504.504v4.027c0 .277.226.504.504.504h43.9a.505.505 0 0 0 .504-.504z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M102.984 337.125v4.027a.505.505 0 0 1-.504.504h-43.9a.505.505 0 0 1-.504-.504v-4.027c0-.277.226-.504.504-.504h43.9c.278 0 .504.227.504.504",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M122.186 354.068a.505.505 0 0 0-.504-.504H58.58a.505.505 0 0 0-.504.504v4.027c0 .277.226.504.504.504h63.102a.505.505 0 0 0 .504-.504z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M122.186 354.068v4.027a.505.505 0 0 1-.504.504H58.58a.505.505 0 0 1-.504-.504v-4.027c0-.277.226-.504.504-.504h63.102c.278 0 .504.227.504.504M197.337 353.571l.342.343-2.174 2.174 2.174 2.174-.342.343-2.174-2.174-2.174 2.174-.346-.343 2.174-2.174-2.174-2.174.346-.343 2.174 2.175zM197.337 336.617l.342.343-2.174 2.174 2.174 2.174-.342.343-2.174-2.174-2.174 2.174-.346-.343 2.174-2.174-2.174-2.174.346-.343 2.174 2.175zM197.337 319.674l.342.343-2.174 2.174 2.174 2.174-.342.343-2.174-2.175-2.174 2.175-.346-.343 2.174-2.174-2.174-2.174.346-.343 2.174 2.174z",
  clipRule: "evenodd"
}))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  d: "M394.357 108.715H21.06v22.845h373.297z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#4C767C",
  d: "M394.357 108.715H21.06v22.845h373.297z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M234.532 116.161a.85.85 0 0 0-.848-.849h-56.017a.85.85 0 0 0-.849.849v6.786c0 .467.38.849.849.849h56.017a.85.85 0 0 0 .848-.849z",
  clipRule: "evenodd"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M234.532 116.161v6.786a.85.85 0 0 1-.848.849h-56.017a.85.85 0 0 1-.849-.849v-6.786a.85.85 0 0 1 .849-.849h56.017a.85.85 0 0 1 .848.849",
  clipRule: "evenodd"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M412.775 98.679v304.162c0 5.578-4.522 10.103-10.102 10.103H16.153c-5.578 0-10.1-4.525-10.1-10.103V98.679a10.1 10.1 0 0 1 10.1-10.103h386.52c5.58 0 10.102 4.517 10.102 10.103M27.053 388.221c0 .988.392 1.934 1.09 2.633a3.7 3.7 0 0 0 2.632 1.086h357.277a3.713 3.713 0 0 0 3.723-3.719V113.298a3.724 3.724 0 0 0-3.723-3.726H30.775a3.724 3.724 0 0 0-3.723 3.726z",
  clipRule: "evenodd"
})))), /*#__PURE__*/React.createElement("mask", {
  id: "missing-profile-image_svg__h",
  width: 407,
  height: 166,
  x: 6,
  y: 88,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M412.776 88.576H6.053V253.61h406.723z"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#missing-profile-image_svg__h)"
}, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M412.776 98.679a10.1 10.1 0 0 0-10.103-10.103H16.153a10.1 10.1 0 0 0-10.1 10.103v304.162c0 5.578 4.522 10.103 10.1 10.103h386.52c5.58 0 10.103-4.525 10.103-10.103z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "missing-profile-image_svg__i",
  width: 407,
  height: 325,
  x: 6,
  y: 88,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M412.776 98.679a10.1 10.1 0 0 0-10.103-10.103H16.153a10.1 10.1 0 0 0-10.1 10.103v304.162c0 5.578 4.522 10.103 10.1 10.103h386.52c5.58 0 10.103-4.525 10.103-10.103z"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#missing-profile-image_svg__i)"
}, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "#336468",
  fillRule: "evenodd",
  d: "M368.318 145.011c0-1.98-1.614-3.6-3.602-3.6H54.118a3.607 3.607 0 0 0-3.602 3.6v64.84c0 1.98 1.614 3.6 3.602 3.6h310.598a3.607 3.607 0 0 0 3.602-3.6z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "missing-profile-image_svg__j",
  width: 319,
  height: 73,
  x: 50,
  y: 141,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M368.318 145.011c0-1.98-1.614-3.6-3.602-3.6H54.118a3.607 3.607 0 0 0-3.602 3.6v64.84c0 1.98 1.614 3.6 3.602 3.6h310.598a3.607 3.607 0 0 0 3.602-3.6z"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#missing-profile-image_svg__j)"
}, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  d: "M88.985 203.818c14.575 0 26.389-11.814 26.389-26.388s-11.814-26.389-26.389-26.389-26.388 11.815-26.388 26.389 11.814 26.388 26.388 26.388"
})), /*#__PURE__*/React.createElement("mask", {
  id: "missing-profile-image_svg__k",
  width: 54,
  height: 53,
  x: 62,
  y: 151,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M88.985 203.818c14.575 0 26.389-11.814 26.389-26.388s-11.814-26.389-26.389-26.389-26.388 11.815-26.388 26.389 11.814 26.388 26.388 26.388"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  fill: "#75959A",
  mask: "url(#missing-profile-image_svg__k)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M88.985 213.891c9.954 0 18.023-5.791 18.023-12.934 0-7.144-8.07-12.935-18.023-12.935-9.954 0-18.023 5.791-18.023 12.935 0 7.143 8.07 12.934 18.023 12.934"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M88.965 185.495s8.234-.487 8.234-14.443a8.24 8.24 0 0 0-8.234-8.234 8.24 8.24 0 0 0-8.234 8.234c0 13.956 8.234 14.443 8.234 14.443",
  clipRule: "evenodd"
}))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M88.985 151.041c14.565 0 26.389 11.824 26.389 26.389s-11.824 26.388-26.389 26.388-26.388-11.824-26.388-26.388 11.824-26.389 26.388-26.389m0 2c-13.46 0-24.388 10.928-24.388 24.389s10.928 24.388 24.388 24.388 24.389-10.928 24.389-24.388-10.928-24.389-24.389-24.389",
  clipRule: "evenodd"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M242.737 152.664c0-.892-.726-1.622-1.621-1.622H126.084c-.893 0-1.619.73-1.619 1.622v12.956c0 .892.726 1.622 1.619 1.622h115.032c.895 0 1.621-.73 1.621-1.622z",
  clipRule: "evenodd"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M242.737 152.664v12.956c0 .892-.726 1.622-1.621 1.622H126.084c-.893 0-1.619-.73-1.619-1.622v-12.956c0-.892.726-1.622 1.619-1.622h115.032c.895 0 1.621.73 1.621 1.622",
  clipRule: "evenodd"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M221.357 178.785a.85.85 0 0 0-.849-.849h-95.199a.85.85 0 0 0-.848.849v6.786c0 .467.38.849.848.849h95.199a.85.85 0 0 0 .849-.849z",
  clipRule: "evenodd"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M221.357 178.785v6.786a.85.85 0 0 1-.849.849h-95.199a.85.85 0 0 1-.848-.849v-6.786a.85.85 0 0 1 .848-.849h95.199a.85.85 0 0 1 .849.849",
  clipRule: "evenodd"
}))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  d: "M394.357 108.715H21.06v22.845h373.297z"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  fill: "#4C767C",
  d: "M394.357 108.715H21.06v22.845h373.297z"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M234.533 116.161a.85.85 0 0 0-.849-.849h-56.017a.85.85 0 0 0-.849.849v6.786c0 .467.38.849.849.849h56.017a.85.85 0 0 0 .849-.849z",
  clipRule: "evenodd"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M234.533 116.161v6.786a.85.85 0 0 1-.849.849h-56.017a.85.85 0 0 1-.849-.849v-6.786a.85.85 0 0 1 .849-.849h56.017a.85.85 0 0 1 .849.849",
  clipRule: "evenodd"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M412.776 98.679v304.162c0 5.578-4.523 10.103-10.103 10.103H16.153c-5.578 0-10.1-4.525-10.1-10.103V98.679a10.1 10.1 0 0 1 10.1-10.103h386.52c5.58 0 10.103 4.517 10.103 10.103M27.053 388.221a3.714 3.714 0 0 0 3.723 3.719h357.277a3.716 3.716 0 0 0 3.722-3.719V113.298a3.724 3.724 0 0 0-3.722-3.726H30.776a3.725 3.725 0 0 0-3.723 3.726z",
  clipRule: "evenodd"
})))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  fill: "#336468",
  fillRule: "evenodd",
  d: "M205.674 226.232a2.91 2.91 0 0 0-2.908-2.907H53.422a2.91 2.91 0 0 0-2.908 2.907v52.363a2.913 2.913 0 0 0 2.908 2.907h149.344a2.913 2.913 0 0 0 2.908-2.907z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "missing-profile-image_svg__l",
  width: 156,
  height: 59,
  x: 50,
  y: 223,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M205.674 226.232a2.91 2.91 0 0 0-2.908-2.907H53.422a2.91 2.91 0 0 0-2.908 2.907v52.363a2.913 2.913 0 0 0 2.908 2.907h149.344a2.913 2.913 0 0 0 2.908-2.907z"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#missing-profile-image_svg__l)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  d: "M205.674 222.542H50.514v13.999h155.16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4C767C",
  d: "M205.674 222.542H50.514v13.999h155.16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M94.252 226.34a.8.8 0 0 0-.8-.801H55.532c-.441 0-.8.361-.8.801v6.399c0 .441.359.801.8.801h37.918c.442 0 .8-.36.8-.801z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M94.252 226.34v6.399a.8.8 0 0 1-.8.801H55.532c-.441 0-.8-.36-.8-.801v-6.399c0-.44.359-.801.8-.801h37.918c.442 0 .8.361.8.801",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M113.013 243.371c0-.33-.269-.6-.6-.6h-57.08a.6.6 0 0 0-.6.6v4.8c0 .33.268.6.6.6h57.08c.331 0 .6-.27.6-.6z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M113.013 243.371v4.8c0 .33-.269.6-.6.6h-57.08a.6.6 0 0 1-.6-.6v-4.8a.6.6 0 0 1 .6-.6h57.08c.331 0 .6.27.6.6M54.908 270.091a.17.17 0 0 1-.172-.171v-.61c0-.094.078-.17.172-.17h8.826c.094 0 .172.076.172.17v.61a.17.17 0 0 1-.172.171zm11.463 0a.17.17 0 0 1-.172-.171v-.61c0-.094.078-.17.172-.17h8.826c.094 0 .172.076.172.17v.61a.17.17 0 0 1-.172.171zm11.463 0a.17.17 0 0 1-.172-.171v-.61c0-.094.078-.17.172-.17h8.826c.094 0 .172.076.172.17v.61a.17.17 0 0 1-.172.171zm11.458 0a.17.17 0 0 1-.167-.171v-.61a.17.17 0 0 1 .167-.17h8.83c.095 0 .173.076.173.17v.61a.17.17 0 0 1-.172.171zm11.468 0a.17.17 0 0 1-.172-.171v-.61c0-.094.072-.17.172-.17h8.826c.094 0 .172.076.172.17v.61a.17.17 0 0 1-.172.171zm11.458 0a.167.167 0 0 1-.167-.171v-.61c0-.094.072-.17.167-.17h8.831c.094 0 .172.076.172.17v.61a.17.17 0 0 1-.172.171zm11.463 0a.17.17 0 0 1-.172-.171v-.61a.17.17 0 0 1 .172-.17h8.831c.094 0 .172.076.172.17v.61a.17.17 0 0 1-.172.171zm11.463 0a.167.167 0 0 1-.167-.171v-.61c0-.094.072-.17.167-.17h8.831c.094 0 .172.076.172.17v.61a.17.17 0 0 1-.172.171zm11.463 0a.17.17 0 0 1-.172-.171v-.61a.17.17 0 0 1 .172-.17h8.831c.094 0 .172.076.172.17v.61a.17.17 0 0 1-.172.171zm11.463 0a.17.17 0 0 1-.172-.171v-.61c0-.094.078-.17.172-.17h8.831c.094 0 .172.076.172.17v.61a.17.17 0 0 1-.172.171zm11.463 0a.17.17 0 0 1-.172-.171v-.61a.17.17 0 0 1 .172-.17h8.831c.094 0 .172.076.172.17v.61a.17.17 0 0 1-.172.171zm11.463 0a.17.17 0 0 1-.172-.171v-.61a.17.17 0 0 1 .172-.17h8.831c.094 0 .166.076.166.17v.61a.167.167 0 0 1-.166.171zm11.463 0a.17.17 0 0 1-.172-.171v-.61c0-.094.078-.17.172-.17h8.831c.094 0 .166.076.166.17v.61a.167.167 0 0 1-.166.171z",
  clipRule: "evenodd"
}))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  fill: "#336468",
  fillRule: "evenodd",
  d: "M368.314 226.232a2.913 2.913 0 0 0-2.909-2.907H216.062a2.913 2.913 0 0 0-2.909 2.907v52.363a2.913 2.913 0 0 0 2.909 2.907h149.343a2.913 2.913 0 0 0 2.909-2.907z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "missing-profile-image_svg__m",
  width: 156,
  height: 59,
  x: 213,
  y: 223,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M368.314 226.232a2.913 2.913 0 0 0-2.909-2.907H216.062a2.913 2.913 0 0 0-2.909 2.907v52.363a2.913 2.913 0 0 0 2.909 2.907h149.343a2.913 2.913 0 0 0 2.909-2.907z"
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#missing-profile-image_svg__m)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  d: "M368.314 223.33H213.153v13.211h155.161z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4C767C",
  d: "M368.314 223.33H213.153v13.211h155.161z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M283.233 226.737a.8.8 0 0 0-.801-.801h-64.26c-.442 0-.8.36-.8.801v6.399c0 .44.358.801.8.801h64.26a.803.803 0 0 0 .801-.801z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M283.233 226.737v6.399c0 .44-.359.801-.801.801h-64.26a.8.8 0 0 1-.8-.801v-6.399c0-.441.358-.801.8-.801h64.26c.442 0 .801.36.801.801",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M294.987 243.372a.6.6 0 0 0-.6-.601h-33.928c-.331 0-.6.271-.6.601v4.8c0 .33.269.6.6.6h33.928c.331 0 .6-.27.6-.6z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M294.987 243.372v4.8c0 .33-.269.6-.6.6h-33.928c-.331 0-.6-.27-.6-.6v-4.8c0-.33.269-.601.6-.601h33.928c.331 0 .6.271.6.601",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillRule: "evenodd",
  d: "M326.02 258.255a.6.6 0 0 0-.6-.601h-63.779c-.331 0-.6.271-.6.601v4.799c0 .331.269.601.6.601h63.779c.331 0 .6-.27.6-.601z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  fillRule: "evenodd",
  d: "M326.02 258.255v4.799a.6.6 0 0 1-.6.601h-63.779c-.331 0-.6-.27-.6-.601v-4.799c0-.33.269-.601.6-.601h63.779c.331 0 .6.271.6.601",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#75959A",
  d: "M234.937 277.894c9.7 0 17.564-7.864 17.564-17.564 0-9.701-7.864-17.564-17.564-17.564s-17.564 7.863-17.564 17.564c0 9.7 7.864 17.564 17.564 17.564"
}))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.12,
  d: "M320.859 610.83c27.493 0 49.781-4.083 49.781-9.12s-22.288-9.12-49.781-9.12-49.78 4.083-49.78 9.12 22.288 9.12 49.78 9.12"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  fill: "#E8C9A6",
  fillRule: "evenodd",
  d: "M392.723 355.502s13.275 23.125 10.64 40.915c0 0-20.18 24.365-30.22 27.515 0 0 6.385-29.58 13.92-35.375 0 0-14.305-5.25-17.44-33.4-2.8-25.15 22.835-1.145 23.1.345M311.621 361.463s4.785 14.078-13.017 27.993c-7.711 5.185-35.201-46.239-37.284-57.167 0 0 21.587 13.57 26.446 18.957 0 0 7.548-10.397 19.123-4.349 22.426 11.722 5.889 13.591 4.732 14.566M295.433 590.853l-.935 10.025 4.1-.545 1.705-8.84zM343.941 591.492l1.692 9.926 3.819-1.588-.641-8.98z",
  clipRule: "evenodd"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  fill: "#E85E27",
  fillRule: "evenodd",
  d: "M286.203 601.302a1.05 1.05 0 0 0 .272 1.738c1.579.695 4.951 1.526 11.234.543a3.155 3.155 0 0 0-.975-6.233c-6.283.983-9.241 2.803-10.531 3.952M346.054 603.525c.42.072.852.072 1.272 0 1.436-.25 4.807-1.053 4.807-3.059 0-1.739-2.439-3.15-5.443-3.15s-5.443 1.411-5.443 3.15c0 2.006 3.371 2.809 4.807 3.059",
  clipRule: "evenodd"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  fill: "#7D5E53",
  fillRule: "evenodd",
  d: "M288.203 593.608s11.475.525 14.15 1.295l30.395-91.6s11.05-72.9 10.45-75.715c-.6-2.82-37.515-7.095-40.355-1.15-2.845 5.95-2.47 20.48-2.465 31.515.01 11.04-12.175 135.655-12.175 135.655",
  clipRule: "evenodd"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  fill: "#7D5E53",
  fillRule: "evenodd",
  d: "M329.288 492.243s10.105 97.36 11.97 102.66l12.635 2.285s16.814-118.205 17.609-125.84c1.115-10.695.886-42.92-2.174-43.64-3.055-.725-30.05-.855-30.05-.855s-13.77 42.615-9.99 65.39",
  clipRule: "evenodd"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M286.988 349.283s1.145 6.64 18.23 21.045l12.545 32.83 55.555-16.495-1.205-10.725s-.265-4.805.41-5.135c.63-.305 1.01 5.62 2.06 5.035 5.645-3.14 17.185-11.94 18.48-22.08 0 0-6.4-18.075-13.72-23.745-7.68-5.945-31.36-23.085-63.66-14.28-4.205 1.145-8.75 3.28-12.58 6.155 0 0-15.76 23.105-16.115 27.395",
  clipRule: "evenodd"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  fill: "#E85E27",
  fillRule: "evenodd",
  d: "M304.788 322.002s-1.44 42.715 1.205 53.305c2.64 10.59-7.765 39.56-7.38 45.53.38 5.97 3.945 12.25 15.53 5.215l9.83-62.155s-13.09-40.485-7.91-48.915c0 0-10.745 2.785-11.275 7.02",
  clipRule: "evenodd"
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  fill: "#E85E27",
  fillRule: "evenodd",
  d: "M314.143 426.053s25.105 13.2 55.395 1.765c0 0 4.335-10.3 4.32-15.38-.01-5.075-1.445-22.785.025-26.815 0 0-29.465-20.685-13.52-66.87 0 0-4.325-4.19-7.675-2.73 0 0-5.735 26.22-28.715 47.875 0 0-.355.095-.845.23a4.56 4.56 0 0 0-3.295 3.7c-1.555 10.145-6.71 43.8-8.16 53.285a4.55 4.55 0 0 0 1.545 4.155c.51.435.925.785.925.785",
  clipRule: "evenodd"
})), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
  fill: "#E8C9A6",
  fillRule: "evenodd",
  d: "M376.202 422.139s-6.288-1.661-8.742-1.176a2.854 2.854 0 0 0-2.246 3.349 2.854 2.854 0 0 0 3.351 2.242c2.455-.486 7.637-4.415 7.637-4.415",
  clipRule: "evenodd"
})), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
  fill: "#E8C9A6",
  fillRule: "evenodd",
  d: "M374.765 422.695s-.885-3.256-1.74-4.232a1.48 1.48 0 0 0-2.087-.141 1.48 1.48 0 0 0-.137 2.087c.854.977 3.964 2.286 3.964 2.286M264.469 334.373s-4.615-4.583-6.983-5.39a2.856 2.856 0 0 0-3.62 1.777 2.855 2.855 0 0 0 1.782 3.618c2.368.807 8.821-.005 8.821-.005",
  clipRule: "evenodd"
})), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
  fill: "#E8C9A6",
  fillRule: "evenodd",
  d: "M262.918 334.131s.862-3.261.61-4.535a1.48 1.48 0 0 0-1.737-1.165 1.48 1.48 0 0 0-1.163 1.739c.252 1.273 2.29 3.961 2.29 3.961M325.973 303.153s.587 6.309-.018 12.588a8.556 8.556 0 0 0 13.354 7.903q.004.002.004 0c3.903-2.679 3.878-9.979 5.465-9.451 0 0-4.328-8.843-.417-14.645 3.91-5.802-14.136 6.16-18.388 3.605",
  clipRule: "evenodd"
})), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
  fill: "#E8C9A6",
  fillRule: "evenodd",
  d: "M323.312 307.628s12.788 7.383 25.589-14.789c4.075-7.059 1.653-16.097-5.405-20.172s-16.096-1.653-20.171 5.405c-12.801 22.172-.013 29.556-.013 29.556",
  clipRule: "evenodd"
})), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
  fill: "#4C3031",
  fillRule: "evenodd",
  d: "M321.742 280.992s1.105-20.039 14.89-13.519c0 0 20.53-5.256 19.405 12.219-1.12 17.48-12.645 18.086-13.11 23.471 0 0-2.74-7.106 3.255-12.271 6.34-5.455 2.71-6.224-2.235-6.849-.62-.08-1.96 3.309-2.46 3.014-.37-.22-.8-4.235-1.12-4.545-3.025-2.96-3.795-9.33-6.82-6.89-6.79-5.765-11.805 5.37-11.805 5.37",
  clipRule: "evenodd"
})), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
  fill: "#29484E",
  fillOpacity: 0.1,
  d: "M324.041 376.826a2.071 2.071 0 1 0 0-4.143 2.071 2.071 0 0 0 0 4.143M322.297 397.426a2.071 2.071 0 1 0 0-4.143 2.071 2.071 0 0 0 0 4.143M316.673 420.027a2.072 2.072 0 1 0-.002-4.144 2.072 2.072 0 0 0 .002 4.144"
})), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
  fill: "#E64E14",
  d: "M323.812 376.659a2.071 2.071 0 1 0 0-4.143 2.071 2.071 0 0 0 0 4.143"
})), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
  fill: "#330400",
  fillOpacity: 0.1,
  d: "M324.208 374.713a.327.327 0 1 1 .327-.566.327.327 0 0 1-.327.566M323.513 374.311a.327.327 0 1 1 .326-.567.327.327 0 0 1-.326.567M323.793 375.434a.327.327 0 1 1 .326-.566.327.327 0 0 1-.326.566M323.098 375.032a.327.327 0 1 1 .326-.567.327.327 0 0 1-.326.567"
})), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
  fill: "#E64E14",
  d: "M321.901 397.174a2.07 2.07 0 1 0 0-4.141 2.07 2.07 0 0 0 0 4.141"
})), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
  fill: "#330400",
  fillOpacity: 0.1,
  d: "M322.268 394.914a.328.328 0 0 1-.17-.632.327.327 0 0 1 .17.632M321.492 395.121a.327.327 0 1 1-.168-.632.327.327 0 0 1 .168.632M322.482 395.717a.326.326 0 1 1-.169-.631.327.327 0 1 1 .169.631M321.707 395.925a.327.327 0 1 1-.17-.632.327.327 0 0 1 .17.632"
})), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
  fill: "#E64E14",
  d: "M316.478 419.802a2.07 2.07 0 1 0 0-4.141 2.07 2.07 0 0 0 0 4.141"
})), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
  fill: "#330400",
  fillOpacity: 0.1,
  d: "M316.883 417.642a.326.326 0 1 1-.001-.653.326.326 0 0 1 .001.653M316.077 417.642a.327.327 0 1 1 0-.654.327.327 0 0 1 0 .654M316.883 418.475a.326.326 0 1 1-.001-.653.326.326 0 0 1 .001.653M316.077 418.475a.327.327 0 1 1 0-.654.327.327 0 0 1 0 .654"
})), /*#__PURE__*/React.createElement("mask", {
  id: "missing-profile-image_svg__n",
  width: 151,
  height: 339,
  x: 253,
  y: 266,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M261.925 334.613c4.621 14.445 29.402 59.724 36.662 54.844 3.3-2.58 5.823-5.165 7.745-7.665-.825 12.96-8.056 34.05-7.735 39.045.191 2.965 1.167 6.01 3.522 7.455-2.069 6.745-1.759 19.645-1.752 29.665.007 11.035-12.178 135.65-12.178 135.65s3.404.156 6.936.426l-.343 3.669c-4.964 1.025-7.434 2.58-8.588 3.6a1.05 1.05 0 0 0 .272 1.74c1.584.695 4.953 1.525 11.235.54a3.152 3.152 0 0 0 1.352-5.674l.664-3.451c1.133.135 2.068.286 2.623.446l28.65-86.346c2.967 27.96 8.872 82.421 10.256 86.346l3.369.61.335 1.964c-2.153.42-3.704 1.6-3.704 2.99 0 2.005 3.367 2.806 4.803 3.061.421.07.851.07 1.273 0 1.435-.255 4.803-1.056 4.803-3.061 0-1.195-1.147-2.235-2.837-2.77l-.098-1.36 4.69.85s16.816-118.205 17.609-125.84c1.087-10.445.893-41.415-1.962-43.54.031-.075.33-.789.757-1.894 1.325-.64 2.844-1.615 4.011-2.415 10.35-4.48 29.068-27.081 29.068-27.081 2.634-17.79-10.637-40.914-10.637-40.914q.21-.869.324-1.745s-6.4-18.075-13.72-23.745c-3.486-2.7-10.271-7.706-19.663-11.546-1.342-1.195-4.441-3.549-6.988-2.449a68 68 0 0 0-7.914-1.826c-.092-.19-2.799-5.844-1.849-11.029q.098-.534.251-1.06c1.768-4.49 11.816-6.15 12.859-22.41 1.121-17.475-19.408-12.22-19.408-12.22-13.785-6.52-14.889 13.52-14.889 13.52s.218-.485.625-1.2q-.326.608-.625 1.2c-10.086 19.905 1.571 26.635 1.571 26.635s1.074.619 2.912.959a72 72 0 0 1-.111 5.12 70 70 0 0 0-10.431 2.026c.114-.27.24-.525.38-.75 0 0-7.585 1.969-10.325 5.104a38 38 0 0 0-2.637 1.801s-15.761 23.105-16.113 27.395c0 0 .11.645.779 1.965-3.76-4.17-17.525-13.23-23.57-17.12-.225-.215-.589-.565-1.041-.98.234-1.065.538-2.725.375-3.55a1.478 1.478 0 1 0-2.899.569c.066.33.251.756.49 1.206-1.277-1.045-2.665-2.05-3.659-2.39a2.85 2.85 0 0 0-1.837 5.395c1.403.475 4.234.39 6.312.235m82.808-20.426c-.032-.005-.063-.015-.095-.02q.047.006.095.02m29.249 106.155c-.29-.755-.633-1.495-.97-1.88a1.3 1.3 0 0 0-.173-.17c.585-2.145 1.01-4.255 1.006-5.85-.012-5.08-1.448-22.789.024-26.819 0 0-.269-.191-.744-.566l-1.024-9.12s-.269-4.805.406-5.13c.633-.31 1.013 5.615 2.06 5.03q.272-.148.561-.319c5.234 10.58 11.934 13.039 11.934 13.039-5.908 4.545-11.111 23.725-13.08 31.785"
}))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  fill: "#29484E",
  fillOpacity: 0.1,
  fillRule: "evenodd",
  clipRule: "evenodd",
  mask: "url(#missing-profile-image_svg__n)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M326.212 308.588c7.741.322 5.972 16.922 8.984 16.526 4.641-.611 6.382-3.201 7.725-7.449.077-.244.401-2.135 1.98-2.407 2.528-.436 3.829.755 7.352.634.416-3.618-7.679-1.64-7.487-1.703.346-5.898-1.026-11.261 3.27-15.61 17.134-17.347 5.943-27.434 5.672-27.891-.368-.619.418 15.19-4.672 12.565-7.413-3.823-11.133-9.471-14.222-8.473-.069.022-.839-.19-1.852-.404-1.086-.229-2.451-.46-3.537-.406-2.171.106-3.298 1.276-3.442 1.389-.066.051 2.268-1.065 4.096-1.033 2.009.036 3.53 1.222 3.458 1.296-.188.192 1.125-.974 6.476 7.738 1.107 1.802 1.843 2.98 1.463 3.698-.142.268-2.193 3.016-1.84 3.09.18.038 4.645-4.945 4.902-4.929 1.789.108 5.028-.095 3.853 2.585-.529 1.205-3.114 3.139-3.857 4.276-5.299 8.112-11.883 16.099-18.322 16.508M254.739 329.467c-3.355 3.611-2.088 5.13.955 5.734 2.421.481 5.332.652 6.451 3.465 7.741 19.448 27.082 60.415 36.969 53.15 1.329-.976 3.959-6.242 7.218-10.023-7.186 21.5-3.532 17.451-2.444 14.777 5.521-13.576 4.007-29.945.51-54.815-.091-.645-.15 23.526-.96 23.625-2.68.326-6.233-3.919-7.189-3.275 3.475 3.588 8.405 7.705 8.953 8.221.022.227.051.505.136 1.223-5.155 4.18-9.512 7.931-9.693 7.822-16.61-9.917-30.769-45.595-33.927-45.49-3.088.103-7.204-.184-6.979-4.414"
}), /*#__PURE__*/React.createElement("path", {
  d: "M262.354 328.432c1.671 1.215-.705 3.173.79 4.711 1.721 1.769 1.886-4.614-.79-4.711M371.753 421.197c-.03-.025-.015-.025.06.005-2.44-1.455-.865-2.955-.705-3.02-.26.55 1.02.65 1.48.905 1.625.895.815 2.945 1.665 2.005 1.805-1.985 14.65-19.46 17.565-32.25 1.33-5.84-5.315-11.495-10.93-17.305.38-.315.78-.62 1.16-.955-12.87-1.77-12.715-28.245-13.74-20.12-1.18 9.35 1.1 14.45 1.1 14.45-1.04 1.365-3.45 4.01-5.2 6.025-.51.595-12.64-9.17-4.235-51.075-11.185 33.655 2.7 52.28 2.815 52.9.525 2.875-2.415 11.98 2.37 20.47 4.29 7.615 2.585 21.33 0 24.46-2.725 3.3-4.41 7.25-1.705 11.64-9.195 2.425-27.3 6.085-47.73-2.58 5.185-1.645 15.44-35.525 11.6-54.12-.57-2.735-2.105-7.605-3.365-8.735.52 1.965 2.23 5.99 2.635 8.62 2.88 18.765-5.915 51.59-12.465 53.535-4.7 2.92-8.86 4-12.01 2.24 1.995 3.44 11.78-.06 11.78-.06 1.005 3.83 49.29 7.275 50.395 15.03 7.945 45.3-12.04 110.765-10.41 153.925 10.585 18.035 26.34-140.745 18.25-166.015 9.415-1.89 4.495-3.245 4.06-3.3l.005.015q-.066-.022-.005-.015c-.35-1.87-1.125-3.3-1.935-4.35-1.73 1.185-4.215 2.735-5.7 3.03a2.844 2.844 0 0 1-3.345-2.24 2.846 2.846 0 0 1 2.24-3.345c1.015-.2 2.69-.035 4.3.23"
}), /*#__PURE__*/React.createElement("path", {
  d: "M302.34 594.905c3.14-5.199 19.153-45.904 28.651-86.344.347-1.479.687-5.483.949-6.567 2.021-8.345-1.936-32.931-3.322-38.913-.638 2.338 2.685 34.593-.983 44.587-11.407 31.072-32.51 86.364-32.51 86.364 1.003 3.832 35.4 13.644 7.215.873"
})))));
export default SvgMissingProfileImage;